// Constants extracted from usePipelineState to keep the hook focused on
// useMemo composition. Pure data — no logic.

import type { StageInfo, StageKey } from "../StagesSidebar";

// Status -> human-readable message used when synthesizing pending
// PipelineStep rows for a freshly triggered (queued/in_progress) run.
export const SYNTHETIC_STATUS_MESSAGES: Record<string, string> = {
  completed: "Completed",
  in_progress: "In Progress",
  failed: "Failed",
  pending: "Queued",
};

// Maps the DB Application.status (lowercased) to a StagesSidebar stage status.
// The DB status is the authoritative source for the Summary stage; the
// pipeline_state-derived status can be stale when events are lost.
export const DB_STATUS_TO_STAGE_STATUS: Record<string, StageInfo["status"]> = {
  running: "completed",
  failed: "failed",
  provisioning_failed: "failed",
  building: "in_progress",
  deploying: "in_progress",
  provisioning: "in_progress",
  vcs_provisioned: "idle",
  draft: "idle",
  stopped: "idle",
};

// Default status when a DB status is not present in the map above.
export const DEFAULT_STAGE_STATUS: StageInfo["status"] = "pending";

// Ordered stage definitions for the StagesSidebar. Status is filled in
// at runtime by deriveStages().
export const STAGE_DEFINITIONS: ReadonlyArray<{
  key: StageKey;
  label: string;
}> = [
  { key: "summary", label: "Summary" },
  { key: "setup", label: "VCS Provisioning" },
  { key: "build", label: "Build" },
  { key: "deploy", label: "Deploy" },
];
